export default __webpack_public_path__ + "static/media/fhub-home.fa32d138.webp";